// c61_207 — the frontend bundle's own identity. The Deploy
// Verification card and useVersionCheck compare this against the
// server's cycle_marker to detect a browser tab executing a STALE
// cached bundle (deploys land server-side but the tab keeps old JS).
// BUMP THIS with every cycle_registry.py entry — a pytest
// (test_c61_207_bulk_propose_hard_timeout.py) enforces the match.
export const BUNDLE_CYCLE = "c61_553_qb_truth";
